export enum DataPeriod {
    None = 0,
    Month = 1,
    Day = 2
}
